import { render } from "./when.vue?vue&type=template&id=48d540b2&scoped=true"
import script from "./when.vue?vue&type=script&lang=js"
export * from "./when.vue?vue&type=script&lang=js"

import "./when.vue?vue&type=style&index=0&id=48d540b2&lang=scss&scoped=true"

import exportComponent from "/Users/admin/Codes/d86e-client-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d540b2"]])

export default __exports__